export type FeedLevel = "info" | "success" | "error";

export interface Feed {
  log: (message: string, level?: FeedLevel) => void;
  clear: () => void;
  /**
   * When `true`, the feed hides everything except error entries.
   * Implementation: sets `data-filter="errors"` on the list element;
   * CSS does the actual hiding. Existing entries stay in the DOM so
   * toggling back off re-shows them instantly with no reflow churn.
   */
  setErrorsOnly: (on: boolean) => void;
}

const MAX_ENTRIES = 200;

export function attachFeed(container: HTMLElement): Feed {
  const list = document.createElement("div");
  list.className = "feed-list";
  container.appendChild(list);

  function log(message: string, level: FeedLevel = "info"): void {
    const entry = document.createElement("div");
    entry.className = `feed-entry feed-entry--${level}`;

    const time = document.createElement("span");
    time.className = "feed-time";
    time.textContent = formatTime(new Date());
    entry.appendChild(time);

    const msg = document.createElement("span");
    msg.className = "feed-msg";
    msg.textContent = message;
    entry.appendChild(msg);

    list.appendChild(entry);

    while (list.childElementCount > MAX_ENTRIES) {
      list.firstElementChild?.remove();
    }

    container.scrollTop = container.scrollHeight;
  }

  function clear(): void {
    list.replaceChildren();
  }

  function setErrorsOnly(on: boolean): void {
    if (on) {
      list.setAttribute("data-filter", "errors");
    } else {
      list.removeAttribute("data-filter");
    }
  }

  return { log, clear, setErrorsOnly };
}

function formatTime(d: Date): string {
  const pad = (n: number) => n.toString().padStart(2, "0");
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
